import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const changeHistory = {
  fetchChangeHistory: lazyModuleMethod(
    () => import('./fetchChangeHistory'),
    'default'
  ),
}
